import * as React from "react";
function SvgTrash(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        d="M11 4h10M5 6h22m-5 22H10a2 2 0 01-2-2V10h16v16a2 2 0 01-2 2z"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgTrash);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
